import JassEnum from './enum';

/**
 * type effecttype
 */
export default class JassEffectType extends JassEnum {}
